module.exports = require('./helpers/bundle-url').getBundleURL('2lNV8') + "back-black.243b453b.svg";